import React, { Component } from 'react';
import { render } from 'react-dom';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import 'react-web-tabs/dist/react-web-tabs.css';

class Tab1 extends Component {
	render() {
		return (
			<div className="columns" id="faq">
				<div className="section column">
					<div className="content faq-content">
						<div className="columns">
							<div className="column ">
								<div className="title is-4">
									<h4 className="is-size-3"> Apa Pertanyaanmu ?</h4>
								</div>
								<Tabs defaultTab="vertical-tab-one" vertical>
									<TabList>
										<Tab tabFor="vertical-tab-one">Apa ?</Tab>
										<Tab tabFor="vertical-tab-two">Dimana ?</Tab>
										<Tab tabFor="vertical-tab-three">Bagaimana ?</Tab>
										<Tab tabFor="vertical-tab-four">Mengapa ?</Tab>
									</TabList>
									<TabPanel tabId="vertical-tab-one">
									<h5>Apakah DELIV tersedia di Platform iOS?</h5>
										<p>Untuk sementara ini, aplikasi DELIV hanya tersedia di sistem android. Untuk pengguna iOS harap sabar menunggu. Tim DELIV sedang bekerja untuk menghadirkan aplikasi DELIV di sistem operasi iOS.</p>
									</TabPanel>
									<TabPanel tabId="vertical-tab-two">
										<h5>Dimana sajakah saya bisa menggunakan DELIV?</h5>
										<p>Saat ini DELIV bisadigunakan di Kota Bojonegoro</p>
									</TabPanel>
									<TabPanel tabId="vertical-tab-three">
										<h5>Bagaimana Cara Mendapatkan Aplikasi DELIV ?</h5>
										<p>Masuk kebagian Google PlayStore, lalu ketik dipencarian dengan kata kunci "DELIV". Setelah itu klik Install</p>
									</TabPanel>
									<TabPanel tabId="vertical-tab-four">
										<h5>Mengapa saya harus menggunakan DELIV ?</h5>
										<p>Karena DELIV memberikan kemudahan untuk bisa mengantarkan makanan, barang kesemua tempat dengan biaya yang terjangkau</p>
									</TabPanel>
								</Tabs>
							</div>
						</div>
					</div>
				</div>
				<div className="column is-one-quarter section">
					<figure>
						<img src="/img/banner-gopoint-1.jpg" alt="" />
					</figure>
				</div>
			</div>
		);
	}
}

export default Tab1;
